import { render, staticRenderFns } from "./VenueSettings.vue?vue&type=template&id=4a4cd6ee&scoped=true&"
import script from "./VenueSettings.vue?vue&type=script&lang=js&"
export * from "./VenueSettings.vue?vue&type=script&lang=js&"
import style0 from "./VenueSettings.vue?vue&type=style&index=0&id=4a4cd6ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4cd6ee",
  null
  
)

export default component.exports